/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { AIGeneralBlockCard } from '../../AIGeneralBlockCard';
import './RecordCardRendererStyles.scss';
export function RecordCardRenderer({ block }) {
    const card = block;
    const fieldsContent = (React.createElement("div", { className: "qmb-ui-record-card-renderer" }, card.fields.map((field, index) => (React.createElement("div", { key: index, className: "qmb-ui-record-card-renderer__row" },
        React.createElement("span", { className: "qmb-ui-record-card-renderer__key" }, field.label),
        React.createElement("span", { className: "qmb-ui-record-card-renderer__value" }, field.link_url ? (React.createElement("a", { href: field.link_url, target: "_blank", rel: "noopener noreferrer" }, field.value)) : (field.value)))))));
    const allFieldsText = card.fields.map((field) => `${field.label}: ${field.value}`).join('\n');
    return (React.createElement(AIGeneralBlockCard, { sections: [
            {
                label: card.title,
                content: fieldsContent,
                copyText: allFieldsText
            }
        ], footerGroups: card.url
            ? [
                {
                    actions: [
                        {
                            id: 'open',
                            label: 'Open',
                            icon: 'fa-light fa-arrow-up-right-from-square',
                            onClick: () => window.open(card.url, '_blank', 'noopener,noreferrer')
                        }
                    ]
                }
            ]
            : [] }));
}
